import { createContext, useContext } from "react";

export const StickyVideoContext = createContext({
  isStickyEnabled: false,
  setIsStickyEnabled: () => {},
  isOpenSticky: false,
  playingId: null,
  updateStickyContext: () => {},
  setOverrideStickyContext: () => {}
});

export const useStickyVideoContext = () => useContext(StickyVideoContext);
